export const en_41 = {   
    menu: {
        'send_balance': 'Top-Up Now',
    },
    send_balance: {
        "topup_heading":"Top-Up Now",
        "search_country": "Search island",
        'click_select_country': 'Click here to select island',
        'select_country': 'Please select Island',
        'select_country_placeholder': 'Select Island',
        'mobile_number_placeholder': 'Mobile/Landline Number',
        'enter_mobile_number': "Please enter mobile/landline number",
    }
}